import { getShortcutAttrs, TextShortcut } from './shortcut-plugin';
var blockLeafShortcut = function (regexp, name, config) {
    return new TextShortcut(name, regexp, function (view, state, match, start, end) {
        var nodeType = state.schema.nodes[name];
        if (!nodeType)
            return null;
        var attrs = getShortcutAttrs(config.handler, view, match, start, end);
        if (!attrs)
            return null;
        var $pos = state.doc.resolve(start);
        var newNode = nodeType.create(attrs);
        return state.tr.replaceWith($pos.before(), $pos.after(), newNode);
    }, config);
};
export { blockLeafShortcut };
//# sourceMappingURL=block-leaf-shortcut.js.map